<template>
	<div 
		:class="[{'isLoading h-[300px]' : loading}, {'bg-white' : !loading}]"
		class="rounded-md p-4 mb-3">
		<div class="flex items-center mb-3">
			<div class="flex-1 font-bold w-full truncate pr-4">{{title}}</div>
		

			<div class="flex cursor-pointer" @click="() => (showingUsers = taskUsers, showAssignedUser = true)">
				<div  class="rounded-full overflow-clip border border-white bg-white" :class="[{ '-ml-4': n != 0 }]" v-for="(user, n) in taskUsers.slice(0, 5) || []" :key="n">
					<church-icon class="!w-8 !h-8 " v-if="!user?.avatar[0]" icon="person-circle-fill"></church-icon>
					<img v-else class="w-8 h-8 object-fit " :src="Array.isArray(user?.avatar) ? user?.avatar[0]  : user?.avatar ||  ''" alt="">
				</div>
			
				<span
					v-if="taskUsers?.length > 5"
					class="w-8 h-8 rounded-full overflow-clip border border-white -ml-4 bg-gray flex items-center justify-center">5+</span>
			</div>
		</div>

		<div v-for="(task, n) in modifiedTasks" :key="n">
			<div 
				@click="() => showTaskList = task"
				class="grid grid-cols-6 content-center mb-2">
				<div class="col-span-2 pr-3 text-sm text-gray-1 leading-tight">{{task.name}}</div>
				<div class="col-span-3 flex items-center">
					<div class="w-full rounded-lg h-1 bg-gray-2 overflow-clip ">
						<div :style="{ width: computePercent(task), backgroundColor : color }" class="bg-violet h-full rounded-lg"></div>
					</div>
				</div>
				<div class="text-sm text-center text-gray-1">{{computePercent(task)}}</div>
			</div>
		</div>
		
		
		<template v-if="goals?.length > 0">
			<hr>
			
			<div class="flex items-center mb-3">
				<div class="font-bold w-full truncate pr-4">Tasks assigned to goals</div>

				

				<div class="flex cursor-pointer" @click="() => (showingUsers = goalUsers, showAssignedUser = true)">
					<div  class="rounded-full overflow-clip border border-white bg-white" :class="[{ '-ml-4': n != 0 }]" v-for="(user, n) in goalUsers.slice(0, 5) || []" :key="n">
						<church-icon class="!w-8 !h-8 " v-if="!user?.avatar[0] || !user?.avatar" icon="person-circle-fill"></church-icon>
						<img v-else class="w-8 min-w-8 h-8 object-fit " :src="Array.isArray(user?.avatar) ? user?.avatar[0]  :  user?.avatar || ''" alt="">
					</div>
				
					<span
						v-if="goalUsers?.length > 5"
						class="w-8 h-8 rounded-full overflow-clip border border-white -ml-4 bg-gray flex items-center justify-center">5+</span>
				</div>
			</div>

			<div v-for="(goal, n) in goals" :key="n">
				<div 
					class="grid grid-cols-6 content-center mb-2">
					<div class="col-span-2 pr-3 text-sm text-gray-1 leading-tight">{{goal.name}}</div>
					<div class="col-span-3 flex items-center">
						<div class="w-full rounded-lg h-1 bg-gray-2 overflow-clip ">
							<div :style="{ width: computePercent(goal), backgroundColor : color }" class="bg-violet h-full rounded-lg"></div>
						</div>
					</div>
					<div class="text-sm text-center text-gray-1">{{computePercent(goal)}}</div>
				</div>
			</div>


		</template>

		<m-assigned-users-pop 
			:users="showingUsers || []"
			:editMode="false" 
			:show.sync="showAssignedUser" 
			:assignedUsers="taskUsers" />


		<m-task-list-pop 
			@close="() => showTaskList = null"
			:show="showTaskList ? true : false"
			:taskName="showTaskList?.name"
			:tasks="showTaskList?.tasks || []"/>
	</div>
</template>

<script setup>
import StringParser from '@/helpers/stringParser';
import { computed, defineProps, ref } from 'vue';

/* ========== PROPS ===== */
const props = defineProps({
	tasks : { type: Array, default: () => [] },
	title : { type: String, default: '' },
	color : { type: String, default: '#13b57a' },
	loading : { type: Boolean, default: false },
	taskUsers : { type: Array, default: () => [] },
	goals : { type: Array, default: () => [] }
})


/* ============== STATES ====== =========== */
const showAssignedUser = ref(false)
const showTaskList = ref(null)
const showingUsers = ref(null)


/* ========= COMPUTED ===== */
/**
 * Modified task list 
 */
const modifiedTasks = computed(() => {
	return [...props?.tasks].map(t => {
		return {
			...t,
			id : StringParser.makeString(5)
		}
	})
})

/**
 * Goals all users
 */
const goalUsers = computed(() => {
	return props?.goals?.reduce((acc, goal) => {
		return [...acc, ...(goal?.goalUsers || [])]
	}, [])
	?.filter((a, b ,c ) => c.findIndex(cf => Number(cf?.ID) == Number(a?.ID)) == b) // remove duplicate 
})

/* ============== METHDOS =========== */
/**
 * Compute percentage
 * @param {Object} task
 */
const computePercent = (task) => {
	return `${Math.round((task.completed / task.total) * 100)}%`
}

</script>